function mhRemoveDescription() {
    if($('.category-perex').length>0){
        if ($('meta[property="og:image"]').length && $('meta[property="og:image"]').attr('content').indexOf('/logos/') === -1) {
            $('.category-top').append('<div class="absoluteCategoryImage"><img src="' + $('meta[property="og:image"]').attr('content') + '" alt="' + $('.category-title').text() + '"></div>');
        }
        $('.category-top').addClass('havePerex')
    }
    if ($('.subcategories').length) {
        $('.subcategories li img').each(function () {
            if ($(this).attr('src').includes('/folder.svg')) {
                $('.subcategories').addClass('thirdLevel');
            }
            $(this).attr('src', $(this).attr('src').replace('/thumb/', '/orig/'));
        });
        $('.category-top').after($('.subcategories'));
        
    }
    if ($('.subcategories .parametric').length) {
        if (!$('.parametrickSubcat').length) {
            $('.category-content-wrapper').before('<div class="parametrickSubcat"><h3>Oblíbené kategorie</h3><ul class="parametricSubcategories"></ul></div>');
        }
        if ($('.subcategories .parametric').length) {
            
            $('.parametricSubcategories').append($('.subcategories .parametric'));
        }
       
    }

    
}

$(document).ready(function () {
    mhRemoveDescription();
  });
  document.addEventListener('ShoptetDOMContentLoaded', function () {
    mhRemoveDescription();
  });
  document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    mhRemoveDescription();
  });
  document.addEventListener('ShoptetPageFilterValueChange', function () {
    mhRemoveDescription();
  });